export type EntityFreshness = {
  staleTime?: number;
  refetchOnWindowFocus?: boolean;
  refetchOnReconnect?: boolean;
};

export type EntityStrategy = {
  strategy: 'client' | 'server';
  freshness?: EntityFreshness;
};

const LIVE_ENTITY_FRESHNESS = {
  staleTime: 30 * 1000,
  refetchOnWindowFocus: true,
  refetchOnReconnect: true,
} satisfies EntityFreshness;

export const ENTITY_CONFIG = {
  properties: { strategy: 'client' }, // client
  tenants: { strategy: 'client' }, // client
  leases: { strategy: 'client' }, // client
  invoices: { strategy: 'server', freshness: LIVE_ENTITY_FRESHNESS },
  reminder_templates: { strategy: 'server' }, // client
  reminder_actions: { strategy: 'server', freshness: LIVE_ENTITY_FRESHNESS },
  payments: { strategy: 'server', freshness: LIVE_ENTITY_FRESHNESS },
  comm_events: { strategy: 'server', freshness: LIVE_ENTITY_FRESHNESS },
  invoice_edit_history: { strategy: 'server' },
  lessors: { strategy: 'client' },
} satisfies Record<string, EntityStrategy>;

export type EntityName = keyof typeof ENTITY_CONFIG;
